import { Card } from '@eventbrite/eds-card';
import { Trending as TrendingSvg } from '@eventbrite/eds-iconography';
import {
    GRID_TYPE,
    MediaCardContent,
    STANDARD_STYLE,
} from '@eventbrite/eds-media-card-content';
import { gettext } from '@eventbrite/i18n';
import upperFirst from 'lodash/upperFirst';
import React from 'react';
import { Header } from '../../components/Header/Header';
import { ThingsToDoSection } from '../../components/ThingsToDoSection';
import { useLocationContext } from '../../context';
import './TrendingSearches.scss';

export type Trending = {
    id: number;
    term: string;
    search_path: string;
}[];

export interface TrendingSearchesProps {
    trending: Trending;
    viewMoreMarkedNoFollow?: boolean;
}

const _formattedTitle = (id: number, searchTerm: string) => (
    <span className="eds-text-bl eds-text-weight--regular eds-text-bm eds-text-color--ui-blue">
        {id + 1}. {upperFirst(searchTerm)}
    </span>
);

const _getTrendingSearchCards = (trending: Trending) => {
    const classes =
        'eds-l-pad-hor-3 eds-l-pad-vert-2 eds-g-cell eds-g-cell-md-3-12 eds-g-cell-12-12';

    return trending.map(({ id, term, search_path }) => (
        <div key={id} className={classes} data-testid="media-card">
            <Card style="simple" containerClassName="trending-searches-card">
                <MediaCardContent
                    style={STANDARD_STYLE}
                    type={GRID_TYPE}
                    linkUrl={search_path}
                    title={_formattedTitle(id, term)}
                    shouldHideImage={true}
                />
            </Card>
        </div>
    ));
};

const _getTrendingSearchesPathForLocation = (slug: string) =>
    `/trending/searches/${slug}/`;

export const TrendingSearches: React.FunctionComponent<
    TrendingSearchesProps
> = (props) => {
    const { location_slug, shortPlaceName } = useLocationContext();
    const { trending, viewMoreMarkedNoFollow = false } = props;
    const trendingSearchesPath = _getTrendingSearchesPathForLocation(
        location_slug || '',
    );

    const trendingTitle =
        shortPlaceName === 'Online'
            ? gettext('Trends Online')
            : gettext('Trends in %(shortPlaceName)s', {
                  shortPlaceName: shortPlaceName,
              });

    return (
        <>
            {trending?.length ? (
                <ThingsToDoSection>
                    <Header
                        title={trendingTitle}
                        iconType={<TrendingSvg />}
                        linkUrl={trendingSearchesPath}
                        template="trending_searches"
                        viewMoreMarkedNoFollow={viewMoreMarkedNoFollow}
                    />
                    <div className="eds-g-group">
                        {_getTrendingSearchCards(trending)}
                    </div>
                </ThingsToDoSection>
            ) : (
                <></>
            )}
        </>
    );
};
